import Icon from '../../components/Icon.vue'

Icon.register({"brands/affiliatetheme":{"width":512,"height":512,"paths":[{"d":"M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1 105.5 88.2 170.8 48.3 199.9 69.9 229 91.5 211 166.5 159.7 237.4zM510.9 180.1C437.1 303.5 319 367.8 246.4 323.7 221.4 308.5 205.1 282.5 197.4 249.9 163.8 314.7 104.6 363.7 33.3 383.1 83.1 442.4 157.4 480 240.3 480 390.3 480 511.9 356.9 511.9 205.1 512 196.6 511.6 188.3 510.9 180.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/affiliatetheme.js
// module id = 5JoZ
// module chunks = 0